var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFundacao = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 165,
  height: 110,
  viewBox: "-5 -2 165 120",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "multiply"
  },
  opacity: 0.72,
  d: "M157.122 85.078H87.891a8.056 8.056 0 01-6.76-3.56L60.391 43.88c-3.23-4.98.573-11.305 6.76-11.305h89.621",
  fill: "url(#paint0_linear)"
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.976 104.873c3.568 0 6.46-2.887 6.46-6.449s-2.892-6.449-6.46-6.449c-3.567 0-6.46 2.888-6.46 6.45 0 3.561 2.893 6.448 6.46 6.448zM33.913 104.873c3.568 0 6.46-2.887 6.46-6.449s-2.892-6.449-6.46-6.449-6.46 2.888-6.46 6.45c0 3.561 2.892 6.448 6.46 6.448zM50.85 104.935c3.568 0 6.46-2.887 6.46-6.449s-2.892-6.449-6.46-6.449-6.46 2.887-6.46 6.45c0 3.561 2.892 6.448 6.46 6.448zM67.786 104.935c3.568 0 6.46-2.887 6.46-6.449s-2.892-6.449-6.46-6.449-6.46 2.887-6.46 6.45c0 3.561 2.892 6.448 6.46 6.448z",
  fill: "#727D79"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.417 104.898c3.568 0 6.46-2.887 6.46-6.449S18.986 92 15.418 92s-6.46 2.887-6.46 6.45c0 3.561 2.892 6.448 6.46 6.448zM32.354 104.898c3.568 0 6.46-2.887 6.46-6.449S35.922 92 32.354 92s-6.46 2.887-6.46 6.45c0 3.561 2.892 6.448 6.46 6.448zM49.29 104.96c3.569 0 6.461-2.887 6.461-6.449s-2.892-6.449-6.46-6.449-6.46 2.887-6.46 6.45c0 3.561 2.892 6.448 6.46 6.448zM66.227 104.96c3.568 0 6.46-2.887 6.46-6.449s-2.892-6.449-6.46-6.449-6.46 2.887-6.46 6.45c0 3.561 2.892 6.448 6.46 6.448z",
  fill: "#ACACAC"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M61.4 13.278a5.286 5.286 0 00-3.76-2.13 5.298 5.298 0 00-4.097 1.383l-55.25 50.946a5.405 5.405 0 00-1.725 3.826 5.395 5.395 0 001.538 3.905l6.361 6.45a5.3 5.3 0 003.966 1.614 5.308 5.308 0 003.866-1.839l48.89-57.407a5.373 5.373 0 00.212-6.748z",
  fill: "#079D56"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M133.6 82.65a6.5 6.5 0 00-1.718-8.104 6.531 6.531 0 00-2.685-1.271 6.755 6.755 0 00-.682-3.695 6.778 6.778 0 00-6.183-3.745 6.791 6.791 0 00-3.598 1.103 8.603 8.603 0 00-2.593-4.597 8.624 8.624 0 00-9.983-1.234 8.61 8.61 0 00-3.638 3.826 8.405 8.405 0 00-10.127 1.893l9.466 27.054",
  fill: "#EDF1F0"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M87.998 48.731l-2.582 1.632 22.023 34.709 2.581-1.633-22.022-34.708z",
  fill: "#079D56"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "multiply"
  },
  d: "M87.998 48.731l-2.581 1.632 22.022 34.709 2.582-1.633-22.023-34.708z",
  fill: "url(#paint1_linear)"
}), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M53.12 12.93l42.952 76.157 4.316-3.549L74.197 2.123A4.457 4.457 0 0071.226-.81a4.472 4.472 0 00-4.1.804L53.12 12.93z",
  fill: "#006B3F"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M108.145 109.392l-.125-29.469-12.334 8.715s3.305 12.762 12.459 20.754z",
  fill: "#079D56"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M108.145 109.392s28.149 5.902 29.596-29.12a1.248 1.248 0 00-1.185-1.245l-3.418-.087a1.246 1.246 0 00-1.247 1.108l-.099 1.245a1.247 1.247 0 01-1.248 1.108l-2.382.012a1.25 1.25 0 01-1.172-1.245v-.958a1.246 1.246 0 00-1.135-1.245l-2.494-.15a1.248 1.248 0 00-1.248 1.17v.772a1.243 1.243 0 01-1.247 1.245l-1.821-.087a1.246 1.246 0 01-1.147-1.32v-.647a1.24 1.24 0 00-.752-1.218 1.25 1.25 0 00-.495-.101h-2.869a1.246 1.246 0 00-1.247 1.033c-.1.697-4.565.386-4.565.386",
  fill: "#00D38D"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "multiply"
  },
  d: "M108.145 109.392s28.149 5.902 29.595-29.12a1.247 1.247 0 00-1.184-1.245l-3.418-.087a1.246 1.246 0 00-1.247 1.108l-.1 1.245a1.245 1.245 0 01-1.247 1.108l-2.382.012a1.248 1.248 0 01-1.172-1.245v-.958a1.246 1.246 0 00-1.135-1.245l-2.495-.15a1.248 1.248 0 00-1.247 1.17v.772a1.243 1.243 0 01-1.247 1.245l-1.821-.087a1.246 1.246 0 01-1.147-1.32v-.647a1.249 1.249 0 00-1.247-1.32h-2.869a1.246 1.246 0 00-1.247 1.034c-.1.697-4.989.299-4.565.386",
  fill: "url(#paint2_linear)"
}), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M15.455 64.846H-3.926A6.069 6.069 0 00-10 70.91v4.794a6.068 6.068 0 006.074 6.063h19.38a6.068 6.068 0 006.075-6.063v-4.794a6.069 6.069 0 00-6.074-6.063z",
  fill: "#006B3F"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "M55.44 87.767a18.664 18.664 0 013.155-6H5.877s3.978 4.058 3.903 6.772",
  fill: "#079D56"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  d: "M55.44 87.767a18.664 18.664 0 013.155-6H5.877s3.978 4.058 3.903 6.772",
  fill: "#079D56"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "multiply"
  },
  d: "M55.44 87.767a18.664 18.664 0 013.155-6H5.877s3.978 4.058 3.903 6.772",
  fill: "url(#paint3_linear)"
}), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M73.137 109.953H11.514a11.495 11.495 0 01-8.122-3.359 11.454 11.454 0 010-16.215 11.497 11.497 0 018.122-3.359h61.623a11.503 11.503 0 018.122 3.359 11.464 11.464 0 013.364 8.108 11.445 11.445 0 01-3.364 8.107 11.482 11.482 0 01-8.122 3.359zM11.514 92.087a6.416 6.416 0 00-4.35 1.97 6.393 6.393 0 000 8.847 6.412 6.412 0 004.35 1.969h61.623a6.412 6.412 0 004.349-1.969 6.392 6.392 0 000-8.848 6.416 6.416 0 00-4.35-1.969H11.515z",
  fill: "#ACACAC"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "multiply"
  },
  opacity: 0.63,
  d: "M73.137 109.953H11.514a11.495 11.495 0 01-8.122-3.359 11.454 11.454 0 010-16.215 11.497 11.497 0 018.122-3.359h61.623a11.503 11.503 0 018.122 3.359 11.464 11.464 0 013.364 8.108 11.445 11.445 0 01-3.364 8.107 11.482 11.482 0 01-8.122 3.359zM11.514 92.087a6.416 6.416 0 00-4.35 1.97 6.393 6.393 0 000 8.847 6.412 6.412 0 004.35 1.969h61.623a6.412 6.412 0 004.349-1.969 6.392 6.392 0 000-8.848 6.416 6.416 0 00-4.35-1.969H11.515z",
  fill: "url(#paint4_linear)"
}), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M5.764 81.766v-5.677a7.113 7.113 0 011.427-4.262 7.134 7.134 0 013.699-2.56l2.644-.773a7.137 7.137 0 003.238-1.994 7.116 7.116 0 001.75-3.372l3.119-14.94a7.107 7.107 0 012.49-4.1 7.13 7.13 0 014.531-1.59h22.799a7.132 7.132 0 015.043 2.078 7.11 7.11 0 012.09 5.032v32.158",
  fill: "#00D38D"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M51.46 42.498H28.663a7.129 7.129 0 00-4.494 1.596 7.106 7.106 0 00-2.477 4.07l-3.118 14.94a7.118 7.118 0 01-4.99 5.365l-2.643.772a7.134 7.134 0 00-3.7 2.56 7.113 7.113 0 00-1.426 4.263v5.677h52.78V49.608a7.098 7.098 0 00-2.09-5.032 7.122 7.122 0 00-5.043-2.078z",
  fill: "#00D38D"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "multiply"
  },
  d: "M51.51 42.498H28.663a7.129 7.129 0 00-4.494 1.596 7.106 7.106 0 00-2.477 4.07l-3.118 14.94a7.093 7.093 0 01-4.99 5.365l-2.656.772a7.134 7.134 0 00-3.691 2.564 7.113 7.113 0 00-1.422 4.259v5.677h52.78V49.608a7.103 7.103 0 00-2.072-5.014 7.127 7.127 0 00-5.011-2.096z",
  fill: "url(#paint5_linear)"
}), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M27.091 46.308a1.973 1.973 0 00-1.933 1.556l-3.742 16.982a1.977 1.977 0 001.933 2.403H34.15v-20.94h-7.059z",
  fill: "#EDF1F0"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "multiply"
  },
  d: "M27.091 46.308a1.973 1.973 0 00-1.933 1.556l-3.742 16.982a1.977 1.977 0 001.933 2.403H34.15v-20.94h-7.059z",
  fill: "url(#paint6_linear)"
}), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M54.666 54.002a7.825 7.825 0 00-2.346-5.449 7.852 7.852 0 00-5.499-2.245H36.694V67.25h16.213a1.984 1.984 0 001.946-2.004l-.187-11.243z",
  fill: "#EDF1F0"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "multiply"
  },
  d: "M54.666 54.002a7.825 7.825 0 00-2.346-5.449 7.852 7.852 0 00-5.499-2.245H36.694V67.25h16.213a1.984 1.984 0 001.946-2.004l-.187-11.243z",
  fill: "url(#paint7_linear)"
}), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M37.966 70.935H35.41c-.248 0-.45.2-.45.448v.373c0 .248.202.448.45.448h2.556c.248 0 .45-.2.45-.448v-.373a.449.449 0 00-.45-.448z",
  fill: "#006B3F"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "M53.12 12.93l2.494 13.558.062-.05 3.068-3.623",
  fill: "#079D56"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 59.218,
  y1: 58.833,
  x2: 157.109,
  y2: 58.833,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#727D79"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 97.703,
  y1: 85.082,
  x2: 97.703,
  y2: 48.74,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00D38D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 3509.47,
  y1: 2602.13,
  x2: 2852.01,
  y2: 2238.94,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00D38D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 676.978,
  y1: 550.444,
  x2: 2904.85,
  y2: 550.444,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00D38D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 6418.32,
  y1: 1919.59,
  x2: 680.179,
  y2: 1919.59,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#727D79"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 675.599,
  y1: 2032.48,
  x2: 2910.32,
  y2: 2032.48,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00D38D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 21.342,
  y1: 56.779,
  x2: 34.15,
  y2: 56.779,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D7D8D6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear",
  x1: 716.569,
  y1: 1018.18,
  x2: 981.509,
  y2: 1018.18,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D7D8D6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFundacao);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fundacao.51ea0af153ef62400881537d8191ebc0.svg";